/**
 * Typography tokens - text styles based on current usage in the codebase
 * Defines consistent font sizes, weights, and line heights
 */

export const typographyTokens = {
  // Font family
  fontFamily: "'DM Sans', 'Inter', Arial, sans-serif",

  // Headings
  heading1: {
    fontSize: 40,
    fontWeight: 700,
    lineHeight: 1.2,
  },

  heading2: {
    fontSize: 28,
    fontWeight: 700,
    lineHeight: 1.2,
  },

  heading3: {
    fontSize: 24,
    fontWeight: 600,
    lineHeight: 1.3,
  },

  heading4: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: 1.3,
  },

  heading5: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 1.4,
  },

  heading6: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.4,
  },

  // Body text
  body1: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
  },

  body2: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.5,
  },

  // Specialized text
  button: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'none' as const,
  },

  caption: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.4,
  },

  overline: {
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 1.4,
    textTransform: 'uppercase' as const,
  },

  // Additional utility styles found in codebase
  label: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 1.4,
  },

  // Comfortable settings labels use the established 15px desktop scale.
  settingsLabel: {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.4,
  },

  buttonLarge: {
    fontSize: 20,
    fontWeight: 500,
    textTransform: 'none' as const,
  },
} as const;
